<se-fe-grid seFeGridOpts>
  <se-fe-grid-cell seFeGridOpts>
    <h3>Variant Options</h3>
  </se-fe-grid-cell>
</se-fe-grid>
@for (spec of specOptionValues() | keyvalue; track spec) {
  <se-fe-grid seFeGridOpts>
    <se-fe-grid-cell seFeGridOpts>
      <se-fe-form-field [seFeDataConfig]="{label: spec.key}"></se-fe-form-field>
      <p class="spec-options">{{ spec.value.join(', ') }}</p>
    </se-fe-grid-cell>
  </se-fe-grid>
}
<se-fe-grid seFeGridOpts>
  <se-fe-grid-cell id="product-detail__product-variant-table" seFeGridOpts>
    @if (variantTableReady) {
      <se-fe-table-wrapper>
        <table seFeTable seFeTableSort title="Product variants" [dataSource]="variantTableDatasource()">
          <ng-container seFeColumnDef="name">
            <th seFeDataRef="name" seFeTableSortHeader seFeHeaderCell *seFeHeaderCellDef>Variants</th>
            <td seFeCell *seFeCellDef="let row">{{ row.name }}</td>
          </ng-container>
          <ng-container seFeColumnDef="sku">
            <th seFeDataRef="sku" seFeTableSortHeader seFeHeaderCell *seFeHeaderCellDef>SKU</th>
            <td seFeCell *seFeCellDef="let row">{{ row.sku }}</td>
          </ng-container>
          @if (showInventory()) {
            <ng-container seFeColumnDef="available">
              <th seFeDataRef="available" seFeTableSortHeader seFeHeaderCell *seFeHeaderCellDef>Available</th>
              <td seFeCell *seFeCellDef="let row">{{ row.available }}</td>
            </ng-container>
          }
          <ng-container seFeColumnDef="status">
            <th seFeDataRef="status" seFeTableSortHeader seFeHeaderCell *seFeHeaderCellDef>Status</th>
            <td seFeCell *seFeCellDef="let row">
              <se-fe-switch
                [id]="row.id"
                [seFeDataChecked]="row.status"
                (seFeChange)="action({id: row.id, active: !row.status})"></se-fe-switch>
            </td>
          </ng-container>
          <tr seFeHeaderRow *seFeHeaderRowDef="variantColumns()"></tr>
          <tr seFeRow *seFeRowDef="let row; columns: variantColumns()"></tr>
        </table>
      </se-fe-table-wrapper>
    }
  </se-fe-grid-cell>
</se-fe-grid>
<se-fe-modal #confirmDisableVariants [seFeDataActions]="disableVariantModalButtons">
  <div seFeModalContent>
    <h3>Are you sure that you want to disable all Product variants?</h3>
    <p>
      If you disable all variants, the product will be changed to inactive. Products with variants must have one variant
      enabled in order to be available to sell.
    </p>
  </div>
</se-fe-modal>
